/* eslint-disable jsx-a11y/mouse-events-have-key-events */
/* eslint-disable no-unused-vars */
/* eslint-disable padding-line-between-statements */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable prefer-destructuring */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-plusplus */
/* eslint-disable no-await-in-loop */
/* eslint-disable jsx-a11y/media-has-caption */
import React, { useEffect, useRef, useState } from 'react';
import { Button, useMediaQuery, useTheme } from '@material-ui/core';
import ReactHlsPlayer from 'react-hls-player';
import { useHistory } from 'react-router-dom';
import clsx from 'clsx';

import { ClipEditSelectionProps } from './ClipEditSection.types';
import { useStyles, VideoSlider } from './ClipEditSection.styles';
import { Loader, Typography } from 'shared/components';
import { AppRoute } from 'app/routing/AppRoute.enum';
import { useLocale } from 'shared/hooks';
import pauseVideoIcon from 'assets/icons/pause-video.png';
import playVideoIcon from 'assets/icons/play-video.png';

// function ValueLabelComponent(props: any) {
//   const { children, open, value, startTime } = props;
//   const adjustedValue = (Number(value / 10) - startTime).toFixed(2); // Calculate display value as 1 to 15
//   return (
//     <Tooltip open={open} enterTouchDelay={0} placement="bottom" title={`${adjustedValue}s`}>
//       {children}
//     </Tooltip>
//   );
// }

export const ClipEditSelection = ({
  activeStep,
  setActiveStep,
  startTime,
  setSelectedRange,
  streamURL,
  isFromCeremony,
  participantId,
  setClipDuration,
  setClipAudioTime,
}: // sliderValue,
ClipEditSelectionProps) => {
  const styles = useStyles();
  const videoRef = useRef<HTMLVideoElement | null>(null);
  const hiddenVideoRef = useRef<HTMLVideoElement | null>(null);
  const [metadataLoaded, setMetadataLoaded] = useState(false);
  const { push } = useHistory();
  const [isLoading, setIsLoading] = useState(true);
  const [isPlaying, setIsPlaying] = useState(true);
  const [isHovered, setIsHovered] = useState(false);
  const [pausedTime, setPausedTime] = useState<number | null>(null);
  const [pausedMarkerPosition, setPausedMarkerPositionIsPlaying] = useState(0);
  const { formatMessage } = useLocale();
  const [thumbnail, setThumbnail] = useState<string | null>(null); // For the thumbnail URL
  // const [hoverTime, setHoverTime] = useState<number | null>(null); // Hovered timestamp
  const [hoverPosition, setHoverPosition] = useState<{ x: number; y: number } | null>(null);
  const { breakpoints } = useTheme();
  const [extendedTime, setExtendedTIme] = useState<number>(15);

  // const [isPlaying, setIsPlaying] = useState(false);
  const startedAt = startTime * 10;
  const endedAt = (startTime + extendedTime) * 10;
  // const endedAtt = startTime + 15;

  const [value, setValue] = useState<number[]>([startedAt, endedAt]);
  const [playbackTime, setPlaybackTime] = useState(startedAt); // Store the current playback time
  const isMobile = useMediaQuery(breakpoints.down('sm'));

  const handleBack = () => {
    setActiveStep(activeStep - 1);
  };

  // function formatTime(seconds: number): string {
  //   const hours = Math.floor(seconds / 3600);
  //   const minutes = Math.floor((seconds % 3600) / 60);
  //   const remainingSeconds = Math.floor(seconds % 60); // Floor to remove decimals

  //   return `${hours.toString().padStart(2, '0')}:${minutes
  //     .toString()
  //     .padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
  // }

  useEffect(() => {
    if (startTime) {
      setValue(() => [startedAt, endedAt]);
      setSelectedRange([startTime, startTime + extendedTime]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startTime]);

  const handleSnackBarClose = () => {
    setActiveStep(activeStep + 1);
  };

  // Automatically play the video on load within the first 15 seconds
  useEffect(() => {
    window.scrollTo(0, 0);

    if (metadataLoaded && videoRef.current && startTime) {
      if (videoRef.current.currentTime >= endedAt) {
        videoRef.current.currentTime = startTime;
        videoRef.current.play(); // Start playing on load
      }
      // setValue([startTime, endedAt]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [metadataLoaded, startTime]);

  // eslint-disable-next-line no-unused-vars
  const fetchThumbnail = (time: number) => {
    // eslint-disable-next-line prefer-const
    let video: HTMLVideoElement | null = hiddenVideoRef.current;
    if (!video) return;

    video.crossOrigin = 'anonymous';

    // Seek to the desired time
    video.currentTime = time;

    // Wait for the video to update to the desired frame
    video.onseeked = () => {
      const canvas = document.createElement('canvas');
      canvas.width = 160; // Thumbnail width
      canvas.height = 90; // Thumbnail height
      const ctx = canvas.getContext('2d');
      if (ctx) {
        try {
          ctx.drawImage(video as CanvasImageSource, 0, 0, canvas.width, canvas.height);
          setThumbnail(canvas.toDataURL('image/jpeg'));
        } catch (e) {
          if (e instanceof Error && e.name === 'SecurityError') {
            // SecurityError: The operation is insecure - handled silently
          } else {
            throw e;
          }
        }
      }
    };
  };

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number | number[]) => {
    // eslint-disable-next-line prefer-const
    let [start, end] = newValue as number[];

    const difference = end - start;

    setClipDuration(difference);

    if (difference < 20) return;

    setValue([start, end]);
    setSelectedRange([start / 10, end / 10]);

    // Seek to the start time if `videoRef` exists
    if (videoRef.current) {
      videoRef.current.currentTime = start / 10;
    }

    fetchThumbnail(start / 10);
  };

  // Handle loaded metadata to start playback from the selected start time
  // eslint-disable-next-line consistent-return
  const handleLoadedMetadata = () => {
    setMetadataLoaded(true);

    if (videoRef.current) {
      videoRef.current.currentTime = startTime; // Start playback from start time
    }
  };

  const handleHiddenLoadedMetadata = () => {
    if (hiddenVideoRef.current) {
      hiddenVideoRef.current.currentTime = startedAt; // Start playback from start time
    }
  };

  const handleTimeUpdate = () => {
    if (videoRef.current) {
      const [selectedStart, selectedEnd] = value;
      // Loop within selected range
      if (videoRef.current.currentTime >= Number(selectedEnd / 10)) {
        videoRef.current.currentTime = Number(selectedStart / 10); // Restart from the beginning of the selected range
        videoRef.current.play(); // Continue playing for seamless looping
      }
      setPlaybackTime(videoRef.current.currentTime * 10);
    }
  };

  const handleWaiting = () => {
    setIsLoading(true); // Show loader when buffering
  };

  const handlePlaying = () => {
    setIsLoading(false); // Hide loader when video starts playing
  };

  const handleSliderMouseMove = (e: React.MouseEvent) => {
    const sliderElement = e.currentTarget as HTMLDivElement;
    const rect = sliderElement.getBoundingClientRect();
    const sliderWidth = rect.width;
    const currentPositionValue = e.clientX - rect.left;

    if (currentPositionValue > sliderWidth) {
      setThumbnail(null);
      return;
    }

    const videoLengthGap = endedAt - startedAt;
    const onePointTimeDifference = videoLengthGap / sliderWidth;
    const currentPointTimeValue = currentPositionValue * onePointTimeDifference;
    const hoverThumbnailTime = startedAt + currentPointTimeValue;

    // setHoverTime(hoverThumbnailTime); // Set hover time in seconds
    setHoverPosition({ x: currentPositionValue, y: e.clientY }); // Set hover position in pixels

    // Fetch thumbnail for hover time
    fetchThumbnail(hoverThumbnailTime / 10);
  };

  const handleSliderMouseLeave = () => {
    setHoverPosition(null);
    // setHoverTime(null);
    setThumbnail(null);
  };

  let markerPosition = ((playbackTime - startedAt) / (endedAt - startedAt)) * 100; // Percentage position

  const handleClick = () => {
    if (videoRef.current) {
      if (isPlaying) {
        videoRef.current.pause();
        setPausedTime(videoRef.current.currentTime);
        setPausedMarkerPositionIsPlaying(markerPosition);
      } else {
        videoRef.current.play();
        if (value.length === 2) {
          videoRef.current.currentTime = pausedTime || value[0];
          if (videoRef.current.currentTime > value[1]) {
            videoRef.current.play();
          }
        } else {
          videoRef.current.currentTime = pausedTime || startTime;

          if (videoRef.current.currentTime >= endedAt) {
            videoRef.current.play();
          }
        }
        markerPosition = pausedMarkerPosition;
        setPausedTime(null);
        setPausedMarkerPositionIsPlaying(0);
      }
      setIsPlaying(!isPlaying);
    }
  };

  const handleExtendTimeUpdate = (time: number) => {
    setExtendedTIme(time);
    setValue([startedAt, startedAt + time * 10]);
    setClipAudioTime(time);
    setSelectedRange([startedAt / 10, (startedAt + time * 10) / 10]);

    if (videoRef.current) {
      videoRef.current.currentTime = startedAt / 10;
    }
  };

  return (
    <>
      <div className={styles.container}>
        {isLoading && (
          <div className={styles.hlsPlayerLoader}>
            <Loader fullScreen />
          </div>
        )}
        <div className={styles.logoContainer}>
          <div
            className={styles.videoContainer}
            onMouseEnter={() => !isMobile && setIsHovered(true)}
            onMouseLeave={() => !isMobile && setIsHovered(false)}
          >
            {!isLoading && (isHovered || isMobile || !isPlaying) && (
              <div className={styles.playButton} onClick={handleClick} data-testid="play">
                {isPlaying ? (
                  // eslint-disable-next-line jsx-a11y/accessible-emoji
                  !isMobile && <img src={pauseVideoIcon} width="24px" height="24px" alt="pause" />
                ) : (
                  // eslint-disable-next-line jsx-a11y/accessible-emoji
                  <img src={playVideoIcon} width="24px" height="24px" alt="play" />
                )}
              </div>
            )}
            <ReactHlsPlayer
              playerRef={videoRef}
              src={streamURL}
              // width="800px"
              height="100%"
              controlsList="nodownload"
              disablePictureInPicture
              playsInline
              // onChange={pauseVideo}
              onLoadedMetadata={handleLoadedMetadata}
              onTimeUpdate={handleTimeUpdate}
              autoPlay
              loop
              className={styles.hlsPlayer}
              muted
              onWaiting={handleWaiting}
              onPlaying={handlePlaying}
            />
            <ReactHlsPlayer
              hidden
              playerRef={hiddenVideoRef}
              src={streamURL}
              // width="800px"
              height="100%"
              controlsList="nodownload"
              disablePictureInPicture
              playsInline
              // onChange={pauseVideo}
              onLoadedMetadata={handleHiddenLoadedMetadata}
              autoPlay
              // loop
              className={styles.hlsPlayer}
              muted
            />
          </div>
          <div className={styles.subTitle}>
            <Typography>
              {formatMessage({
                id: 'studentSelection.clip.edit.sub.header',
              })}
            </Typography>
            <Typography>
              {formatMessage({
                id: 'studentSelection.clip.edit.sub.header.note',
              })}
            </Typography>
          </div>
          <div className={styles.timeExtendContainer}>
            <Typography>Clip too short? Extend your video time by</Typography>
            <div className={styles.timeExtendButtonContainer}>
              <Button
                className={clsx(styles.extendTimeButton, extendedTime === 15 && styles.extendClickedTimeButton)}
                onClick={() => handleExtendTimeUpdate(15)}
              >
                Default
              </Button>
              <Button
                className={clsx(styles.extendTimeButton, extendedTime === 20 && styles.extendClickedTimeButton)}
                onClick={() => handleExtendTimeUpdate(20)}
              >
                20s
              </Button>
              <Button
                className={clsx(styles.extendTimeButton, extendedTime === 40 && styles.extendClickedTimeButton)}
                onClick={() => handleExtendTimeUpdate(40)}
              >
                40s
              </Button>
              <Button
                className={clsx(styles.extendTimeButton, extendedTime === 60 && styles.extendClickedTimeButton)}
                onClick={() => handleExtendTimeUpdate(60)}
              >
                60s
              </Button>
            </div>
          </div>

          {value && value.length === 2 && (
            <div className={styles.sliderContainer}>
              {/* @ts-expect-error - Material-UI v4 styled component type conflict with React 18 */}
              <VideoSlider
                onChange={handleChange}
                value={value}
                min={startedAt}
                max={endedAt}
                valueLabelDisplay="off"
                // ValueLabelComponent={props => <ValueLabelComponent {...props} startTime={startTime} />}
                onMouseMove={handleSliderMouseMove}
                onMouseLeave={handleSliderMouseLeave}
              />
              {markerPosition > 0 && (
                <>
                  <div
                    style={{
                      left: `${pausedMarkerPosition !== 0 ? pausedMarkerPosition : markerPosition}%`,
                    }}
                    className={clsx(styles.playerIndicator, isPlaying && styles.playerIndicatorIsPlaying)}
                  />
                  {/* <LinearProgress
                        variant="determinate"
                        value={markerPosition}
                        style={{
                          position: 'absolute',
                          top: '-4px', // Adjust to align with the slider
                          width: '100%',
                          height: '8px',
                          backgroundColor: 'rgba(0, 0, 0, 0.1)', // Lighter background for contrast
                          zIndex: 1, // Ensure it's above the slider rail
                        }}
                      /> */}
                </>
              )}
              {thumbnail && hoverPosition && (
                <img
                  src={thumbnail}
                  alt="Thumbnail"
                  style={{
                    left: hoverPosition?.x,
                    right: hoverPosition?.y,
                  }}
                  className={styles.thumbnail}
                />
              )}
              {/* <div style={{ marginTop: '20px', fontSize: '14px', textAlign: 'center' }}>
                    {hoverTime !== null && <p>Hover Time: {hoverTime.toFixed(2)} seconds</p>}
                  </div>

                  <div
                    style={{ position: 'relative', width: '100%', height: '20px', background: '#ddd' }}
                    onMouseMove={handleSliderMouseMove}
                  >
                    <Tooltip title={hoverTime !== null ? `Hover Time: ${hoverTime.toFixed(2)} seconds` : ''}>
                      <Typography variant="body2" style={{ position: 'absolute', top: '-25px', left: '50%' }}>
                        Hover over slider
                      </Typography>
                    </Tooltip>
                  </div> */}
              {/* <div style={{ display: 'flex' }}>
                    <div className={styles.inTimeText}>
                      <Typography style={{ fontWeight: 'bold' }}>
                        {sliderValue.length === 2 ? formatTime(sliderValue[0]) : formatTime(startTime ?? 0)}
                      </Typography>
                      <Typography>In time</Typography>
                    </div>

                    <div className={styles.outTimeText}>
                      <Typography style={{ fontWeight: 'bold' }}>
                        {sliderValue.length === 2 ? formatTime(sliderValue[1]) : formatTime(endedAtt ?? 0)}
                      </Typography>
                      <Typography>Out time</Typography>
                    </div>
                  </div> */}
            </div>
          )}
        </div>
        <div className={styles.buttonContainer}>
          {isFromCeremony && (
            <Button
              className={styles.backButton}
              onClick={() => {
                handleBack();
              }}
            >
              Back
            </Button>
          )}
          {!isFromCeremony && (
            <Button
              className={styles.backButton}
              onClick={() =>
                push(`${AppRoute.participantSelection.replace(':participantId', participantId)}?isItemMatched=true`)
              }
            >
              Not You?
            </Button>
          )}
          <Button
            onClick={() => {
              handleSnackBarClose();
            }}
            className={clsx(isLoading ? styles.confirmDisabledButton : styles.confirmButton)}
            disabled={isLoading}
          >
            Next
          </Button>
        </div>
      </div>
    </>
  );
};
